module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh_cn":{"transportCompanies":"运输公司简介","about":"关于"},"zh_hk":{"transportCompanies":"運輸公司簡介","about":"關於"},"en":{"transportCompanies":"Introduction of Transportation Company","about":"about"},"ja":{"transportCompanies":"運送会社の紹介","about":"オン"}}')
  delete Component.options._Ctor
}
